// import { yupResolver } from '@hookform/resolvers/yup';
// import CloseIcon from '@mui/icons-material/Close';
// import {
//   Alert,
//   Autocomplete,
//   Avatar,
//   Box,
//   Button,
//   CircularProgress,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { AppDispatch, RootState } from 'app/store';
// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { Controller, useForm } from 'react-hook-form';
// import {
//   FaCalendarAlt,
//   FaCamera,
//   FaCheckCircle,
//   FaClock,
//   FaFileAlt,
//   FaMapMarkerAlt,
//   FaPills,
//   FaSignature,
//   FaUndo,
//   FaUser
// } from 'react-icons/fa';
// import { FiArrowLeft } from 'react-icons/fi';
// import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { fetchParticipantsList } from 'slices/HomeTilesSlices';
// import { fetchStaffByRoles } from 'slices/NdisSlices/calenderEvents/CalenderEventsSlice';
// import { MedicationIncident } from 'slices/NdisSlices/carporateServices/IncidentsListSlice';
// import {
//   clearMedicationIncidentState,
//   MedicationIncidentFormData,
//   submitMedicationIncident
// } from 'slices/NdisSlices/reportAllForms/medicationIncidentSlice';
// import * as yup from 'yup';

// // Validation schemas
// const mainSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date: yup.string().required('Date of incident is required'),
//     time: yup.string().required('Time of incident is required'),
//     location: yup.string().required('Location is required'),
//     client_name: yup.string().required('Client name is required'),
//     support_worker_name: yup.string().required('Support worker name is required'),
//     medication_details: yup.string().required('Medication details are required'),
//     nature_of_incident: yup.string().required('Nature of incident is required'),
//     other_incident_details: yup.string().when('nature_of_incident', {
//       is: 'Other',
//       then: (schema) => schema.required('Please specify other incident details'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     description: yup.string().required('Detailed description is required'),
//     immediate_actions: yup.string().required('Actions taken are required'),
//     reported_to_healthcare: yup
//       .string()
//       .required('Please specify if reported to a healthcare professional'),
//     healthcare_contact: yup.string().when('reported_to_healthcare', {
//       is: 'Yes',
//       then: (schema) => schema.required('Healthcare professional details are required'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     recommendations: yup.string().required('Recommendations are required'),
//     support_worker_signature: yup.string().required('Signature is required'),
//     date_completed: yup.string().required('Date completed is required'),
//     photo: yup.mixed<File>().optional().default(undefined),
//     client_email: yup.string().optional().default('')
//   })
//   .required();

// const followUpSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date: yup.string().optional().default(''),
//     time: yup.string().optional().default(''),
//     location: yup.string().optional().default(''),
//     client_name: yup.string().optional().default(''),
//     support_worker_name: yup.string().optional().default(''),
//     medication_details: yup.string().optional().default(''),
//     nature_of_incident: yup.string().optional().default(''),
//     other_incident_details: yup.string().when('nature_of_incident', {
//       is: 'Other',
//       then: (schema) => schema.required('Please specify other incident details'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     description: yup.string().optional().default(''),
//     immediate_actions: yup.string().optional().default(''),
//     reported_to_healthcare: yup
//       .string()
//       .required('Please specify if reported to a healthcare professional'),
//     healthcare_contact: yup.string().when('reported_to_healthcare', {
//       is: 'Yes',
//       then: (schema) => schema.required('Healthcare professional details are required'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     recommendations: yup.string().optional().default(''),
//     support_worker_signature: yup.string().optional().default(''),
//     date_completed: yup.string().optional().default(''),
//     photo: yup.mixed<File>().optional().default(undefined),
//     client_email: yup.string().optional().default('')
//   })
//   .required();

// interface StaffMember {
//   name: string;
//   email: string;
// }

// interface Client {
//   label: string;
//   id: number;
//   email: string;
// }

// interface UserDetails {
//   name: string;
//   email: string;
//   role: { role_id: string }[];
// }

// interface Props {
//   initialData?: MedicationIncident;
//   onClose?: () => void;
// }

// const MedicationIncidentReportForm: React.FC<Props> = ({ initialData, onClose }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
//   const dispatch = useDispatch<AppDispatch>();
//   const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
//   const { message, loading, error } = useTypedSelector((state) => state.medicationIncident);
//   const selectedProjectId = useTypedSelector(
//     (state: RootState) => state.homeTilesServices.selectedProjectId
//   );
//   const selectedServiceTitle = useTypedSelector(
//     (state: RootState) => state.serviceSelected.selectedServiceTitle
//   );
//   const participantsList = useTypedSelector(
//     (state: RootState) => state?.homeTilesServices?.participants
//   ) || { participants_list: [] };
//   const supportWorkers = useTypedSelector((state: RootState) =>
//     (state.calendarEvents.staffList?.['Support worker'] || []).map((worker: any) => ({
//       name: worker.name,
//       email: worker.email || ''
//     }))
//   ) as StaffMember[];
//   const staffLoading = useTypedSelector((state: RootState) => state.calendarEvents.loading);
//   const [previewImage, setPreviewImage] = useState<string | null>(null);
//   const [clientsError, setClientsError] = useState<string | null>(null);
//   const [staffError, setStaffError] = useState<string | null>(null);
//   const [isClientsLoading, setIsClientsLoading] = useState(false);
//   const fileInputRef = useRef<HTMLInputElement>(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Local storage data
//   const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//     label?: string;
//     id?: number;
//     email?: string;
//   };
//   const loginInfo = localStorage.getItem('user-details');
//   const userDetails: UserDetails | null = loginInfo ? JSON.parse(loginInfo) : null;

//   // Prepare clients list
//   const clientsList = useMemo(() => {
//     const list =
//       participantsList.participants_list?.map(
//         (participant: { name: string; email: string }, index: number) => ({
//           label: participant.name || `Client ${index + 1}`,
//           id: index + 1,
//           email: participant.email
//         })
//       ) || [];
//     if (
//       selectedClient?.label &&
//       selectedClient?.email &&
//       !list.some((client) => client.label === selectedClient.label)
//     ) {
//       list.push({
//         label: selectedClient.label,
//         id: selectedClient.id || list.length + 1,
//         email: selectedClient.email
//       });
//     }
//     return list;
//   }, [participantsList.participants_list, selectedClient]);

//   // Fetch participants
//   useEffect(() => {
//     if (
//       selectedProjectId &&
//       selectedServiceTitle &&
//       userDetails?.email &&
//       userDetails?.role?.length > 0
//     ) {
//       setIsClientsLoading(true);
//       dispatch(
//         fetchParticipantsList({
//           group_id: selectedProjectId || '',
//           service_name_id: selectedServiceTitle || '',
//           nested_component_id: location.pathname,
//           email: userDetails.email,
//           roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
//           client_name: ''
//         })
//       )
//         .then(() => {
//           setIsClientsLoading(false);
//         })
//         .catch((error: unknown) => {
//           setIsClientsLoading(false);
//           setClientsError('Failed to load clients. Please try again later.');
//         });
//     } else {
//       setIsClientsLoading(false);
//     }
//   }, []);

//   // Fetch support workers
//   useEffect(() => {
//     if (
//       selectedClient?.label &&
//       selectedProjectId &&
//       selectedServiceTitle &&
//       userDetails?.email &&
//       userDetails?.role?.length > 0
//     ) {
//       const approvedUser = userDetails.email.split('@')[0].replace('.', '_');
//       const payload = {
//         group_id: selectedProjectId,
//         service_name_id: selectedServiceTitle.replace(' ', '_'),
//         nested_component_id: 'Staff_List',
//         email_loggedIn_userEmail: userDetails.email,
//         roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
//         client_name: selectedClient.label?.replace(' ', '_') || '',
//         approved_user: approvedUser,
//         curr_loggIn_userRoles: userDetails?.name || ''
//       };

//       dispatch(fetchStaffByRoles(payload));
//     }
//   }, []);

//   const searchParams = new URLSearchParams(location.search);
//   const tabParam = searchParams.get('tab') || 'incidents';
//   const incidentId = searchParams.get('id') || initialData?.id || undefined;

//   // Determine which form section to show based on route
//   const isMainFormRoute = location.pathname === '/medication-IncidentReport';
//   const isFollowUpRoute =
//     location.pathname === '/ndis-operations/corporate-services' && tabParam === 'incidents';

//   // Check if Follow-Up form is already filled
//   const [alreadyFilled, setAlreadyFilled] = useState(false);
//   useEffect(() => {
//     if (isFollowUpRoute && initialData) {
//       const isFilled = [
//         initialData.reported_to_healthcare,
//         initialData.healthcare_contact,
//         initialData.recommendations
//       ].some((field) => field !== undefined && field !== null && field !== '');
//       setAlreadyFilled(isFilled);
//     } else {
//       setAlreadyFilled(false);
//     }
//   }, [initialData, isFollowUpRoute]);

//   // Use separate useForm hooks for each route
//   const defaultDateTime = new Date().toISOString().split('T')[0];
//   const mainForm = useForm<MedicationIncidentFormData>({
//     resolver: yupResolver<MedicationIncidentFormData>(mainSchema),
//     defaultValues: {
//       id: initialData?.id || '',
//       date: initialData?.date || defaultDateTime,
//       time: initialData?.time || '',
//       location: initialData?.location || '',
//       client_name: initialData?.client_name || selectedClient?.label || '',
//       support_worker_name: initialData?.support_worker_name || userDetails?.name || '',
//       medication_details: initialData?.medication_details || '',
//       nature_of_incident: initialData?.nature_of_incident || '',
//       other_incident_details: initialData?.other_incident_details || '',
//       description: initialData?.description || '',
//       immediate_actions: initialData?.immediate_actions || '',
//       reported_to_healthcare: initialData?.reported_to_healthcare || '',
//       healthcare_contact: initialData?.healthcare_contact || '',
//       recommendations: initialData?.recommendations || '',
//       support_worker_signature: initialData?.support_worker_signature || '',
//       date_completed: initialData?.date_completed || defaultDateTime,
//       photo: undefined,
//       client_email: selectedClient?.email || ''
//     }
//   });

//   const followUpForm = useForm<MedicationIncidentFormData>({
//     resolver: yupResolver<MedicationIncidentFormData>(followUpSchema),
//     defaultValues: {
//       id: initialData?.id || '',
//       date: initialData?.date || '',
//       time: initialData?.time || '',
//       location: initialData?.location || '',
//       client_name: initialData?.client_name || selectedClient?.label || '',
//       support_worker_name: initialData?.support_worker_name || userDetails?.name || '',
//       medication_details: initialData?.medication_details || '',
//       nature_of_incident: initialData?.nature_of_incident || '',
//       other_incident_details: initialData?.other_incident_details || '',
//       description: initialData?.description || '',
//       immediate_actions: initialData?.immediate_actions || '',
//       reported_to_healthcare: initialData?.reported_to_healthcare || '',
//       healthcare_contact: initialData?.healthcare_contact || '',
//       recommendations: initialData?.recommendations || '',
//       support_worker_signature: initialData?.support_worker_signature || '',
//       date_completed: initialData?.date_completed || defaultDateTime,
//       photo: undefined,
//       client_email: selectedClient?.email || ''
//     }
//   });

//   const nature_of_incident = isMainFormRoute
//     ? mainForm.watch('nature_of_incident')
//     : followUpForm.watch('nature_of_incident');
//   const reported_to_healthcare = isMainFormRoute
//     ? mainForm.watch('reported_to_healthcare')
//     : followUpForm.watch('reported_to_healthcare');

//   const handleImageChange = (
//     e: React.ChangeEvent<HTMLInputElement>,
//     onChange: (value: File | undefined) => void
//   ) => {
//     const files = e.target.files;
//     if (files && files.length > 0) {
//       const file = files[0];
//       onChange(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreviewImage(reader.result as string);
//       };
//       reader.readAsDataURL(file);
//     } else {
//       setPreviewImage(null);
//       onChange(undefined);
//     }
//   };

//   const handleRemoveImage = () => {
//     setPreviewImage(null);
//     if (isMainFormRoute) {
//       mainForm.setValue('photo', undefined, { shouldValidate: true });
//     } else {
//       followUpForm.setValue('photo', undefined, { shouldValidate: true });
//     }
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const onSubmitMain = async (data: MedicationIncidentFormData) => {
//     try {
//       const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//         email?: string;
//       };
//       const client_email = selectedClient.email || '';
//       if (!client_email) {
//         mainForm.setError('client_email', {
//           type: 'manual',
//           message: 'Client email is required for submission'
//         });
//         return;
//       }

//       const payload: MedicationIncidentFormData = {
//         ...data,
//         client_email
//       };

//       await dispatch(submitMedicationIncident(payload)).unwrap();
//       mainForm.reset();
//       setPreviewImage(null);
//       if (fileInputRef.current) {
//         fileInputRef.current.value = '';
//       }
//       setTimeout(() => dispatch(clearMedicationIncidentState()), 5000);
//     } catch (err) {
//       console.error('Main form submission error:', err);
//       mainForm.setError('root', {
//         type: 'manual',
//         message: 'Failed to submit form. Please check all fields and try again.'
//       });
//     }
//   };

//   const onSubmitFollowUp = async (data: MedicationIncidentFormData) => {
//     try {
//       if (!incidentId) {
//         followUpForm.setError('root', {
//           type: 'manual',
//           message: 'Incident ID is required for follow-up submission'
//         });
//         return;
//       }

//       const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//         email?: string;
//       };
//       const client_email = selectedClient.email || '';
//       if (!client_email) {
//         followUpForm.setError('client_email', {
//           type: 'manual',
//           message: 'Client email is required for submission'
//         });
//         return;
//       }

//       const payload: MedicationIncidentFormData = {
//         id: incidentId,
//         date: initialData?.date || data.date || '',
//         time: initialData?.time || data.time || '',
//         location: initialData?.location || data.location || '',
//         client_name: initialData?.client_name || data.client_name || '',
//         support_worker_name: initialData?.support_worker_name || data.support_worker_name || '',
//         medication_details: initialData?.medication_details || data.medication_details || '',
//         nature_of_incident: initialData?.nature_of_incident || data.nature_of_incident || '',
//         other_incident_details:
//           initialData?.other_incident_details || data.other_incident_details || '',
//         description: initialData?.description || data.description || '',
//         immediate_actions: initialData?.immediate_actions || data.immediate_actions || '',
//         reported_to_healthcare: data.reported_to_healthcare,
//         healthcare_contact: data.healthcare_contact || '',
//         recommendations: initialData?.recommendations || data.recommendations || '',
//         support_worker_signature:
//           initialData?.support_worker_signature || data.support_worker_signature || '',
//         date_completed: initialData?.date_completed || data.date_completed || '',
//         photo: initialData?.photo||"",
//         client_email
//       };

//       await dispatch(submitMedicationIncident(payload)).unwrap();
//       followUpForm.reset();
//       setPreviewImage(null);
//       if (fileInputRef.current) {
//         fileInputRef.current.value = '';
//       }
//       setTimeout(() => dispatch(clearMedicationIncidentState()), 5000);
//       if (onClose) {
//         onClose();
//       }
//     } catch (err) {
//       console.error('Follow-up form submission error:', err);
//       followUpForm.setError('root', {
//         type: 'manual',
//         message: 'Failed to submit follow-up form. Please check all fields and try again.'
//       });
//     }
//   };

//   const handleResetMain = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     mainForm.reset();
//     mainForm.clearErrors();
//     setPreviewImage(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//     dispatch(clearMedicationIncidentState());
//   };

//   const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     followUpForm.reset();
//     followUpForm.clearErrors();
//     setPreviewImage(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//     dispatch(clearMedicationIncidentState());
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//     // Log validation errors for debugging
//     if (isMainFormRoute && Object.keys(mainForm.formState.errors).length > 0) {
//       console.log('Main form validation errors:', mainForm.formState.errors);
//     }
//     if (isFollowUpRoute && Object.keys(followUpForm.formState.errors).length > 0) {
//       console.log('Follow-up form validation errors:', followUpForm.formState.errors);
//     }
//   }, [mainForm.formState.errors, followUpForm.formState.errors, isMainFormRoute, isFollowUpRoute]);

//   return (
//     <Box>
//       <Paper
//         elevation={isMobile ? 1 : 4}
//         sx={{
//           p: isMobile ? 2 : 4,
//           borderRadius: 2,
//           boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             position: 'relative',
//             textAlign: 'center',
//             mb: isMobile ? 2 : 4,
//             px: isMobile ? 1 : 0
//           }}
//         >
//           {!isFollowUpRoute && (
//             <Button
//               onClick={() => navigate(-1)}
//               variant="outlined"
//               startIcon={<FiArrowLeft />}
//               sx={{
//                 position: 'absolute',
//                 left: 0,
//                 top: 0,
//                 borderColor:
//                   theme.palette.mode === 'light'
//                     ? 'rgba(0, 0, 0, 0.23)'
//                     : 'rgba(255, 255, 255, 0.23)',
//                 color: theme.palette.text.primary,
//                 textTransform: 'none',
//                 borderRadius: 2,
//                 px: 2,
//                 py: 1,
//                 '&:hover': {
//                   borderColor: theme.palette.primary.main,
//                   backgroundColor: theme.palette.action.hover
//                 },
//                 ...(isMobile && {
//                   fontSize: '0.75rem',
//                   px: 1.5,
//                   py: 0.5
//                 })
//               }}
//             >
//               {isMobile ? 'Back' : 'Back to Forms'}
//             </Button>
//           )}

//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               mb: 1,
//               flexDirection: isMobile ? 'column' : 'row',
//               mt: isMobile && !isFollowUpRoute ? 4 : 0,
//               gap: isMobile ? 1 : 2
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: theme.palette.warning.light,
//                 p: 1.5,
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}
//             >
//               <FaFileAlt
//                 size={isMobile ? 24 : 32}
//                 style={{
//                   color: theme.palette.warning.contrastText
//                 }}
//               />
//             </Box>
//             <Typography
//               variant={isMobile ? 'h5' : 'h4'}
//               component="h1"
//               sx={{
//                 fontWeight: 600,
//                 lineHeight: 1.2,
//                 color: theme.palette.text.primary
//               }}
//             >
//               {isMainFormRoute
//                 ? 'Medication Incident Report'
//                 : 'Medication Incident Follow-Up Form'}
//             </Typography>
//           </Box>

//           <Typography
//             variant={isMobile ? 'body2' : 'subtitle1'}
//             sx={{
//               color: 'text.secondary',
//               maxWidth: 600,
//               margin: '0 auto',
//               px: isMobile ? 1 : 2,
//               lineHeight: 1.4
//             }}
//           >
//             Ultra Care Services -{' '}
//             {isMainFormRoute
//               ? 'For incidents involving medication'
//               : 'For follow-up actions on medication incidents'}
//           </Typography>
//         </Box>

//         {/* Success/Error Messages */}
//         {message && (
//           <Alert
//             severity="success"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearMedicationIncidentState())}
//           >
//             {message}
//           </Alert>
//         )}
//         {error && (
//           <Alert
//             severity="error"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearMedicationIncidentState())}
//           >
//             {error}
//           </Alert>
//         )}
//         {clientsError && (
//           <Alert severity="error" sx={{ mb: 2 }} onClose={() => setClientsError(null)}>
//             {clientsError}
//           </Alert>
//         )}
//         {staffError && (
//           <Alert severity="error" sx={{ mb: 2 }} onClose={() => setStaffError(null)}>
//             {staffError}
//           </Alert>
//         )}
//         {(mainForm.formState.errors.root || followUpForm.formState.errors.root) && (
//           <Alert severity="error" sx={{ mb: 2 }}>
//             {mainForm.formState.errors.root?.message ||
//               followUpForm.formState.errors.root?.message ||
//               'Please check all fields and try again.'}
//           </Alert>
//         )}
//         {isFollowUpRoute && alreadyFilled && (
//           <Alert severity="warning" sx={{ mb: 2 }}>
//             This follow-up form has already been filled.
//           </Alert>
//         )}

//         {isMainFormRoute && (
//           <form onSubmit={mainForm.handleSubmit(onSubmitMain)}>
//             {/* General Information */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUser
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   General Information
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="date"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date of Incident"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.date}
//                         helperText={mainForm.formState.errors.date?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="time"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Time of Incident"
//                         type="time"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaClock size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.time}
//                         helperText={mainForm.formState.errors.time?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="location"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Location"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaMapMarkerAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.location}
//                         helperText={mainForm.formState.errors.location?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="client_name"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           {...field}
//                           options={clientsList}
//                           getOptionLabel={(option) => option.label || ''}
//                           value={clientsList.find((client) => client.label === field.value) || null}
//                           onChange={(_, newValue) => {
//                             field.onChange(newValue ? newValue.label : '');
//                           }}
//                           loading={isClientsLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               size="small"
//                               label="Client's Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 ),
//                                 endAdornment: (
//                                   <>
//                                     {isClientsLoading ? (
//                                       <CircularProgress color="inherit" size={20} />
//                                     ) : null}
//                                     {params.InputProps.endAdornment}
//                                   </>
//                                 )
//                               }}
//                               error={!!mainForm.formState.errors.client_name}
//                               helperText={mainForm.formState.errors.client_name?.message}
//                             />
//                           )}
//                           noOptionsText="No clients found"
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="support_worker_name"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           {...field}
//                           options={supportWorkers}
//                           getOptionLabel={(option) => option.name || ''}
//                           value={
//                             supportWorkers.find((worker) => worker.name === field.value) || null
//                           }
//                           onChange={(_, newValue) => {
//                             field.onChange(newValue ? newValue.name : '');
//                           }}
//                           loading={staffLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               size="small"
//                               label="Support Worker's Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 ),
//                                 endAdornment: (
//                                   <>
//                                     {staffLoading ? (
//                                       <CircularProgress color="inherit" size={20} />
//                                     ) : null}
//                                     {params.InputProps.endAdornment}
//                                   </>
//                                 )
//                               }}
//                               error={!!mainForm.formState.errors.support_worker_name}
//                               helperText={mainForm.formState.errors.support_worker_name?.message}
//                             />
//                           )}
//                           noOptionsText="No support workers found"
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Medication Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaPills
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.error.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Medication Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="medication_details"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Medication Involved (e.g., morning/dinner meds)"
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.medication_details}
//                         helperText={mainForm.formState.errors.medication_details?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Nature of Incident
//                     </Typography>
//                     <Controller
//                       name="nature_of_incident"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2,
//                             flexWrap: 'wrap'
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Damaged"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Damaged
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Missed"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Missed</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Wrong dose"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Wrong dose
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Wrong person"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Wrong person
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Wrong time"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Wrong time
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Procedure error"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Procedure error
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Refused"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Refused
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Other"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Other</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Medication missing"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Medication missing
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Medication vomited"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Medication vomited
//                               </Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {mainForm.formState.errors.nature_of_incident && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {mainForm.formState.errors.nature_of_incident.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 {nature_of_incident === 'Other' && (
//                   <Grid item xs={12}>
//                     <Controller
//                       name="other_incident_details"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <TextField
//                           size="small"
//                           label="Please Specify Other Incident Details"
//                           fullWidth
//                           margin="normal"
//                           {...field}
//                           error={!!mainForm.formState.errors.other_incident_details}
//                           helperText={mainForm.formState.errors.other_incident_details?.message}
//                         />
//                       )}
//                     />
//                   </Grid>
//                 )}
//                 <Grid item xs={12}>
//                   <Controller
//                     name="description"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Detailed Description"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.description}
//                         helperText={mainForm.formState.errors.description?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="immediate_actions"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Immediate Actions Taken"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.immediate_actions}
//                         helperText={mainForm.formState.errors.immediate_actions?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Was the Incident Reported to a Healthcare Professional?
//                     </Typography>
//                     <Controller
//                       name="reported_to_healthcare"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {mainForm.formState.errors.reported_to_healthcare && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {mainForm.formState.errors.reported_to_healthcare.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 {reported_to_healthcare === 'Yes' && (
//                   <Grid item xs={12}>
//                     <Controller
//                       name="healthcare_contact"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <TextField
//                           size="small"
//                           label="Name and Contact Information"
//                           fullWidth
//                           margin="normal"
//                           {...field}
//                           error={!!mainForm.formState.errors.healthcare_contact}
//                           helperText={mainForm.formState.errors.healthcare_contact?.message}
//                         />
//                       )}
//                     />
//                   </Grid>
//                 )}
//                 <Grid item xs={12}>
//                   <Controller
//                     name="recommendations"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Recommendations to Prevent Future Incidents"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.recommendations}
//                         helperText={mainForm.formState.errors.recommendations?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="photo"
//                     control={mainForm.control}
//                     render={({ field: { onChange, onBlur, ...field } }) => (
//                       <Box>
//                         <TextField
//                           size="small"
//                           label="Upload Photo"
//                           type="file"
//                           fullWidth
//                           margin="normal"
//                           inputRef={fileInputRef}
//                           InputLabelProps={{ shrink: true }}
//                           InputProps={{
//                             startAdornment: (
//                               <InputAdornment position="start">
//                                 <FaCamera size={16} />
//                               </InputAdornment>
//                             ),
//                             inputProps: {
//                               accept: 'image/*'
//                             }
//                           }}
//                           onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
//                             handleImageChange(e, onChange)
//                           }
//                           onBlur={onBlur}
//                           error={!!mainForm.formState.errors.photo}
//                           helperText={mainForm.formState.errors.photo?.message}
//                         />
//                         {previewImage && isLargeScreen && (
//                           <Box sx={{ mt: 1, textAlign: 'left' }}>
//                             <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                               Photo Preview
//                             </Typography>
//                             <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                               <Avatar
//                                 src={previewImage}
//                                 variant="rounded"
//                                 sx={{
//                                   width: isMobile ? '100%' : 150,
//                                   height: 150,
//                                   objectFit: 'contain'
//                                 }}
//                               />
//                               <IconButton
//                                 size="small"
//                                 onClick={handleRemoveImage}
//                                 sx={{
//                                   position: 'absolute',
//                                   top: -10,
//                                   right: -10,
//                                   bgcolor: theme.palette.error.main,
//                                   color: theme.palette.common.white,
//                                   '&:hover': {
//                                     bgcolor: theme.palette.error.dark
//                                   }
//                                 }}
//                               >
//                                 <CloseIcon fontSize="small" />
//                               </IconButton>
//                             </Box>
//                           </Box>
//                         )}
//                       </Box>
//                     )}
//                   />
//                 </Grid>
//                 {previewImage && !isLargeScreen && (
//                   <Grid item xs={12}>
//                     <Box
//                       sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
//                     >
//                       <Box sx={{ position: 'relative' }}>
//                         <Avatar
//                           src={previewImage}
//                           variant="rounded"
//                           sx={{
//                             width: isMobile ? '100%' : 150,
//                             height: isMobile ? 150 : 150,
//                             mt: isMobile ? 1 : 0,
//                             objectFit: 'contain'
//                           }}
//                         />
//                         <IconButton
//                           size="small"
//                           onClick={handleRemoveImage}
//                           sx={{
//                             position: 'absolute',
//                             top: -10,
//                             right: -10,
//                             bgcolor: theme.palette.error.main,
//                             color: theme.palette.common.white,
//                             '&:hover': {
//                               bgcolor: theme.palette.error.dark
//                             }
//                           }}
//                         >
//                           <CloseIcon fontSize="small" />
//                         </IconButton>
//                       </Box>
//                     </Box>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>

//             {/* Support Worker Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUser
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Support Worker Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="support_worker_name"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           {...field}
//                           options={supportWorkers}
//                           getOptionLabel={(option) => option.name || ''}
//                           value={
//                             supportWorkers.find((worker) => worker.name === field.value) || null
//                           }
//                           onChange={(_, newValue) => {
//                             field.onChange(newValue ? newValue.name : '');
//                           }}
//                           loading={staffLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               size="small"
//                               label="Support Worker's Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 ),
//                                 endAdornment: (
//                                   <>
//                                     {staffLoading ? (
//                                       <CircularProgress color="inherit" size={20} />
//                                     ) : null}
//                                     {params.InputProps.endAdornment}
//                                   </>
//                                 )
//                               }}
//                               error={!!mainForm.formState.errors.support_worker_name}
//                               helperText={mainForm.formState.errors.support_worker_name?.message}
//                             />
//                           )}
//                           noOptionsText="No support workers found"
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="support_worker_signature"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Signature"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaSignature size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.support_worker_signature}
//                         helperText={mainForm.formState.errors.support_worker_signature?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="date_completed"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date Completed"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.date_completed}
//                         helperText={mainForm.formState.errors.date_completed?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons for Main Form */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetMain}
//                 disabled={!mainForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Report'}
//               </Button>
//             </Box>
//           </form>
//         )}

//         {isFollowUpRoute && (
//           <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
//             {/* General Information for Follow-Up */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUser
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   General Information
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="client_name"
//                     control={followUpForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           {...field}
//                           options={clientsList}
//                           getOptionLabel={(option) => option.label || ''}
//                           value={clientsList.find((client) => client.label === field.value) || null}
//                           onChange={(_, newValue) => {
//                             field.onChange(newValue ? newValue.label : '');
//                           }}
//                           loading={isClientsLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               size="small"
//                               label="Client's Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 ),
//                                 endAdornment: (
//                                   <>
//                                     {isClientsLoading ? (
//                                       <CircularProgress color="inherit" size={20} />
//                                     ) : null}
//                                     {params.InputProps.endAdornment}
//                                   </>
//                                 )
//                               }}
//                               error={!!followUpForm.formState.errors.client_name}
//                               helperText={followUpForm.formState.errors.client_name?.message}
//                             />
//                           )}
//                           noOptionsText="No clients found"
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="support_worker_name"
//                     control={followUpForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           {...field}
//                           options={supportWorkers}
//                           getOptionLabel={(option) => option.name || ''}
//                           value={
//                             supportWorkers.find((worker) => worker.name === field.value) || null
//                           }
//                           onChange={(_, newValue) => {
//                             field.onChange(newValue ? newValue.name : '');
//                           }}
//                           loading={staffLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               size="small"
//                               label="Support Worker's Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 ),
//                                 endAdornment: (
//                                   <>
//                                     {staffLoading ? (
//                                       <CircularProgress color="inherit" size={20} />
//                                     ) : null}
//                                     {params.InputProps.endAdornment}
//                                   </>
//                                 )
//                               }}
//                               error={!!followUpForm.formState.errors.support_worker_name}
//                               helperText={
//                                 followUpForm.formState.errors.support_worker_name?.message
//                               }
//                             />
//                           )}
//                           noOptionsText="No support workers found"
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Follow-Up Actions */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaCheckCircle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.success.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Follow-Up Actions
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Was the Incident Reported to a Healthcare Professional?
//                     </Typography>
//                     <Controller
//                       name="reported_to_healthcare"
//                       control={followUpForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {followUpForm.formState.errors.reported_to_healthcare && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {followUpForm.formState.errors.reported_to_healthcare.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 {reported_to_healthcare === 'Yes' && (
//                   <Grid item xs={12}>
//                     <Controller
//                       name="healthcare_contact"
//                       control={followUpForm.control}
//                       render={({ field }) => (
//                         <TextField
//                           size="small"
//                           label="Name and Contact Information"
//                           fullWidth
//                           margin="normal"
//                           {...field}
//                           error={!!followUpForm.formState.errors.healthcare_contact}
//                           helperText={followUpForm.formState.errors.healthcare_contact?.message}
//                         />
//                       )}
//                     />
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons for Follow-Up Form */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetFollowUp}
//                 disabled={!followUpForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading || !incidentId}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Follow-Up'}
//               </Button>
//             </Box>
//           </form>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default MedicationIncidentReportForm;

import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import {
  Alert,
  Autocomplete,
  Avatar,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { AppDispatch, RootState } from 'app/store';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  FaCalendarAlt,
  FaCamera,
  FaCheckCircle,
  FaClock,
  FaFileAlt,
  FaMapMarkerAlt,
  FaPills,
  FaSignature,
  FaUndo,
  FaUser
} from 'react-icons/fa';
import { FiArrowLeft } from 'react-icons/fi';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchParticipantsList } from 'slices/HomeTilesSlices';
import { fetchStaffByRoles } from 'slices/NdisSlices/calenderEvents/CalenderEventsSlice';
import { MedicationIncident } from 'slices/NdisSlices/carporateServices/IncidentsListSlice';
import {
  clearMedicationIncidentState,
  MedicationIncidentFormData,
  submitMedicationIncident
} from 'slices/NdisSlices/reportAllForms/medicationIncidentSlice';
import * as yup from 'yup';

// Validation schemas
const mainSchema = yup
  .object({
    id: yup.string().optional(),
    date: yup.string().required('Date of incident is required'),
    time: yup.string().required('Time of incident is required'),
    location: yup.string().required('Location is required'),
    client_name: yup.string().required('Client name is required'),
    support_worker_name: yup.string().required('Support worker name is required'),
    medication_details: yup.string().required('Medication details are required'),
    nature_of_incident: yup.string().required('Nature of incident is required'),
    other_incident_details: yup.string().when('nature_of_incident', {
      is: 'Other',
      then: (schema) => schema.required('Please specify other incident details'),
      otherwise: (schema) => schema.optional().default('')
    }),
    description: yup.string().required('Detailed description is required'),
    immediate_actions: yup.string().required('Actions taken are required'),
    reported_to_healthcare: yup
      .string()
      .required('Please specify if reported to a healthcare professional'),
    healthcare_contact: yup.string().when('reported_to_healthcare', {
      is: 'Yes',
      then: (schema) => schema.required('Healthcare professional details are required'),
      otherwise: (schema) => schema.optional().default('')
    }),
    recommendations: yup.string().required('Recommendations are required'),
    support_worker_signature: yup.string().required('Signature is required'),
    date_completed: yup.string().required('Date completed is required'),
    photo: yup.mixed<File>().optional().default(undefined),
    client_email: yup.string().optional().default(''),
    resolved: yup.string().optional().default('') // Added resolved as optional
  })
  .required();

const followUpSchema = yup
  .object({
    id: yup.string().optional(),
    date: yup.string().optional().default(''),
    time: yup.string().optional().default(''),
    location: yup.string().optional().default(''),
    client_name: yup.string().optional().default(''),
    support_worker_name: yup.string().optional().default(''),
    medication_details: yup.string().optional().default(''),
    nature_of_incident: yup.string().optional().default(''),
    other_incident_details: yup.string().when('nature_of_incident', {
      is: 'Other',
      then: (schema) => schema.required('Please specify other incident details'),
      otherwise: (schema) => schema.optional().default('')
    }),
    description: yup.string().optional().default(''),
    immediate_actions: yup.string().optional().default(''),
    reported_to_healthcare: yup
      .string()
      .required('Please specify if reported to a healthcare professional'),
    healthcare_contact: yup.string().when('reported_to_healthcare', {
      is: 'Yes',
      then: (schema) => schema.required('Healthcare professional details are required'),
      otherwise: (schema) => schema.optional().default('')
    }),
    resolved: yup
      .string()
      .oneOf(['Yes', 'No'], 'Please specify if the incident is resolved')
      .required('Please specify if the incident is resolved'),
    recommendations: yup.string().required('Recommendations are required'),
    support_worker_signature: yup.string().optional().default(''),
    date_completed: yup.string().optional().default(''),
    photo: yup.mixed<File>().optional().default(undefined),
    client_email: yup.string().optional().default('')
  })
  .required();

interface StaffMember {
  name: string;
  email: string;
}

interface Client {
  label: string;
  id: number;
  email: string;
}

interface UserDetails {
  name: string;
  email: string;
  role: { role_id: string }[];
}

interface Props {
  initialData?: MedicationIncident;
  onClose?: () => void;
}

const MedicationIncidentReportForm: React.FC<Props> = ({ initialData, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const dispatch = useDispatch<AppDispatch>();
  const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
  const { message, loading, error } = useTypedSelector((state) => state.medicationIncident);
  const selectedProjectId = useTypedSelector(
    (state: RootState) => state.homeTilesServices.selectedProjectId
  );
  const selectedServiceTitle = useTypedSelector(
    (state: RootState) => state.serviceSelected.selectedServiceTitle
  );
  const participantsList = useTypedSelector(
    (state: RootState) => state?.homeTilesServices?.participants
  ) || { participants_list: [] };
  const supportWorkers = useTypedSelector((state: RootState) =>
    (state.calendarEvents.staffList?.['Support worker'] || []).map((worker: any) => ({
      name: worker.name,
      email: worker.email || ''
    }))
  ) as StaffMember[];
  const staffLoading = useTypedSelector((state: RootState) => state.calendarEvents.loading);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [clientsError, setClientsError] = useState<string | null>(null);
  const [staffError, setStaffError] = useState<string | null>(null);
  const [isClientsLoading, setIsClientsLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Declare searchParams and tabParam once, before usage
  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get('tab') || 'incidents';
  const incidentId = searchParams.get('id') || initialData?.id || undefined;

  const isMainFormRoute = location.pathname === '/medication-IncidentReport';
  const isFollowUpRoute =
    location.pathname === '/ndis-operations/corporate-services' && tabParam === 'incidents';

  // Local storage data
  const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
    label?: string;
    id?: number;
    email?: string;
  };
  const loginInfo = localStorage.getItem('user-details');
  const userDetails: UserDetails | null = loginInfo ? JSON.parse(loginInfo) : null;

  // Prepare clients list
  const clientsList = useMemo(() => {
    const list =
      participantsList.participants_list?.map(
        (participant: { name: string; email: string }, index: number) => ({
          label: participant.name || `Client ${index + 1}`,
          id: index + 1,
          email: participant.email
        })
      ) || [];
    if (
      selectedClient?.label &&
      selectedClient?.email &&
      !list.some((client) => client.label === selectedClient.label)
    ) {
      list.push({
        label: selectedClient.label,
        id: selectedClient.id || list.length + 1,
        email: selectedClient.email
      });
    }
    return list;
  }, [participantsList.participants_list, selectedClient]);

  // Fetch participants
  useEffect(() => {
    if (
      selectedProjectId &&
      selectedServiceTitle &&
      userDetails?.email &&
      userDetails?.role?.length > 0
    ) {
      setIsClientsLoading(true);
      dispatch(
        fetchParticipantsList({
          group_id: selectedProjectId || '',
          service_name_id: selectedServiceTitle || '',
          nested_component_id: location.pathname,
          email: userDetails.email,
          roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
          client_name: ''
        })
      )
        .then(() => {
          setIsClientsLoading(false);
        })
        .catch((error: unknown) => {
          setIsClientsLoading(false);
          setClientsError('Failed to load clients. Please try again later.');
        });
    } else {
      setIsClientsLoading(false);
    }
  }, [selectedProjectId, selectedServiceTitle]);

  // Fetch support workers
  useEffect(() => {
    if (
      selectedClient?.label &&
      selectedProjectId &&
      selectedServiceTitle &&
      userDetails?.email &&
      userDetails?.role?.length > 0
    ) {
      const approvedUser = userDetails.email.split('@')[0].replace('.', '_');
      const payload = {
        group_id: selectedProjectId,
        service_name_id: selectedServiceTitle.replace(' ', '_'),
        nested_component_id: 'Staff_List',
        email_loggedIn_userEmail: userDetails.email,
        roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
        client_name: selectedClient.label?.replace(' ', '_') || '',
        approved_user: approvedUser,
        curr_loggIn_userRoles: userDetails?.name || ''
      };

      dispatch(fetchStaffByRoles(payload));
    }
  }, []);

  // Check if Follow-Up form is already filled
  const [alreadyFilled, setAlreadyFilled] = useState(false);
  useEffect(() => {
    if (isFollowUpRoute && initialData) {
      const isFilled = [
        initialData.reported_to_healthcare,
        initialData.healthcare_contact,
        initialData.recommendations,
        initialData.resolved
      ].some((field) => field !== undefined && field !== null && field !== '');
      setAlreadyFilled(isFilled);
    } else {
      setAlreadyFilled(false);
    }
  }, [initialData, isFollowUpRoute]);

  // Use separate useForm hooks for each route
  const defaultDateTime = new Date().toISOString().split('T')[0];
  const mainForm = useForm<MedicationIncidentFormData>({
    resolver: yupResolver<MedicationIncidentFormData>(mainSchema),
    defaultValues: {
      id: initialData?.id || '',
      date: initialData?.date || defaultDateTime,
      time: initialData?.time || '',
      location: initialData?.location || '',
      client_name: initialData?.client_name || selectedClient?.label || '',
      support_worker_name: initialData?.support_worker_name || userDetails?.name || '',
      medication_details: initialData?.medication_details || '',
      nature_of_incident: initialData?.nature_of_incident || '',
      other_incident_details: initialData?.other_incident_details || '',
      description: initialData?.description || '',
      immediate_actions: initialData?.immediate_actions || '',
      reported_to_healthcare: initialData?.reported_to_healthcare || '',
      healthcare_contact: initialData?.healthcare_contact || '',
      recommendations: initialData?.recommendations || '',
      support_worker_signature: initialData?.support_worker_signature || '',
      date_completed: initialData?.date_completed || defaultDateTime,
      photo: undefined,
      client_email: selectedClient?.email || '',
      resolved: initialData?.resolved || ''
    }
  });

  const followUpForm = useForm<MedicationIncidentFormData>({
    resolver: yupResolver<MedicationIncidentFormData>(followUpSchema),
    defaultValues: {
      id: initialData?.id || '',
      date: initialData?.date || '',
      time: initialData?.time || '',
      location: initialData?.location || '',
      client_name: initialData?.client_name || selectedClient?.label || '',
      support_worker_name: initialData?.support_worker_name || userDetails?.name || '',
      medication_details: initialData?.medication_details || '',
      nature_of_incident: initialData?.nature_of_incident || '',
      other_incident_details: initialData?.other_incident_details || '',
      description: initialData?.description || '',
      immediate_actions: initialData?.immediate_actions || '',
      reported_to_healthcare: initialData?.reported_to_healthcare || '',
      healthcare_contact: initialData?.healthcare_contact || '',
      recommendations: initialData?.recommendations || '',
      support_worker_signature: initialData?.support_worker_signature || '',
      date_completed: initialData?.date_completed || defaultDateTime,
      photo: undefined,
      client_email: selectedClient?.email || '',
      resolved: initialData?.resolved || ''
    }
  });

  const nature_of_incident = isMainFormRoute
    ? mainForm.watch('nature_of_incident')
    : followUpForm.watch('nature_of_incident');
  const reported_to_healthcare = isMainFormRoute
    ? mainForm.watch('reported_to_healthcare')
    : followUpForm.watch('reported_to_healthcare');

  const handleImageChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    onChange: (value: File | undefined) => void
  ) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      onChange(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewImage(null);
      onChange(undefined);
    }
  };

  const handleRemoveImage = () => {
    setPreviewImage(null);
    if (isMainFormRoute) {
      mainForm.setValue('photo', undefined, { shouldValidate: true });
    } else {
      followUpForm.setValue('photo', undefined, { shouldValidate: true });
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const onSubmitMain = async (data: MedicationIncidentFormData) => {
    try {
      const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
        email?: string;
      };
      const client_email = selectedClient.email || '';
      if (!client_email) {
        mainForm.setError('client_email', {
          type: 'manual',
          message: 'Client email is required for submission'
        });
        return;
      }

      const payload: MedicationIncidentFormData = {
        ...data,
        client_email
      };

      await dispatch(submitMedicationIncident(payload)).unwrap();
      mainForm.reset();
      setPreviewImage(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setTimeout(() => dispatch(clearMedicationIncidentState()), 5000);
    } catch (err) {
      console.error('Main form submission error:', err);
      mainForm.setError('root', {
        type: 'manual',
        message: 'Failed to submit form. Please check all fields and try again.'
      });
    }
  };

  const onSubmitFollowUp = async (data: MedicationIncidentFormData) => {
    try {
      if (!incidentId) {
        followUpForm.setError('root', {
          type: 'manual',
          message: 'Incident ID is required for follow-up submission'
        });
        return;
      }

      const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
        email?: string;
      };
      const client_email = selectedClient.email || '';
      if (!client_email) {
        followUpForm.setError('client_email', {
          type: 'manual',
          message: 'Client email is required for submission'
        });
        return;
      }

      const payload: MedicationIncidentFormData = {
        id: incidentId,
        date: initialData?.date || data.date || '',
        time: initialData?.time || data.time || '',
        location: initialData?.location || data.location || '',
        client_name: initialData?.client_name || data.client_name || '',
        support_worker_name: initialData?.support_worker_name || data.support_worker_name || '',
        medication_details: initialData?.medication_details || data.medication_details || '',
        nature_of_incident: initialData?.nature_of_incident || data.nature_of_incident || '',
        other_incident_details:
          initialData?.other_incident_details || data.other_incident_details || '',
        description: initialData?.description || data.description || '',
        immediate_actions: initialData?.immediate_actions || data.immediate_actions || '',
        reported_to_healthcare: data.reported_to_healthcare,
        healthcare_contact: data.healthcare_contact || '',
        recommendations: data.recommendations || '',
        resolved: data.resolved,
        support_worker_signature:
          initialData?.support_worker_signature || data.support_worker_signature || '',
        date_completed: initialData?.date_completed || data.date_completed || '',
        photo: initialData?.photo || '',
        client_email
      };

      await dispatch(submitMedicationIncident(payload)).unwrap();
      followUpForm.reset();
      setPreviewImage(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setTimeout(() => dispatch(clearMedicationIncidentState()), 5000);
      if (onClose) {
        onClose();
      }
    } catch (err) {
      console.error('Follow-up form submission error:', err);
      followUpForm.setError('root', {
        type: 'manual',
        message: 'Failed to submit follow-up form. Please check all fields and try again.'
      });
    }
  };

  const handleResetMain = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    mainForm.reset();
    mainForm.clearErrors();
    setPreviewImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    dispatch(clearMedicationIncidentState());
  };

  const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    followUpForm.reset();
    followUpForm.clearErrors();
    setPreviewImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    dispatch(clearMedicationIncidentState());
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (isMainFormRoute && Object.keys(mainForm.formState.errors).length > 0) {
      console.log('Main form validation errors:', mainForm.formState.errors);
    }
    if (isFollowUpRoute && Object.keys(followUpForm.formState.errors).length > 0) {
      console.log('Follow-up form validation errors:', followUpForm.formState.errors);
    }
  }, [mainForm.formState.errors, followUpForm.formState.errors, isMainFormRoute, isFollowUpRoute]);

  return (
    <Box>
      <Paper
        elevation={isMobile ? 1 : 4}
        sx={{
          p: isMobile ? 2 : 4,
          borderRadius: 2,
          boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: 'relative',
            textAlign: 'center',
            mb: isMobile ? 2 : 4,
            px: isMobile ? 1 : 0
          }}
        >
          {!isFollowUpRoute && (
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              startIcon={<FiArrowLeft />}
              sx={{
                position: 'absolute',
                left: 0,
                top: 0,
                borderColor:
                  theme.palette.mode === 'light'
                    ? 'rgba(0, 0, 0, 0.23)'
                    : 'rgba(255, 255, 255, 0.23)',
                color: theme.palette.text.primary,
                textTransform: 'none',
                borderRadius: 2,
                px: 2,
                py: 1,
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  backgroundColor: theme.palette.action.hover
                },
                ...(isMobile && {
                  fontSize: '0.75rem',
                  px: 1.5,
                  py: 0.5
                })
              }}
            >
              {isMobile ? 'Back' : 'Back to Forms'}
            </Button>
          )}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 1,
              flexDirection: isMobile ? 'column' : 'row',
              mt: isMobile && !isFollowUpRoute ? 4 : 0,
              gap: isMobile ? 1 : 2
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.warning.light,
                p: 1.5,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FaFileAlt
                size={isMobile ? 24 : 32}
                style={{
                  color: theme.palette.warning.contrastText
                }}
              />
            </Box>
            <Typography
              variant={isMobile ? 'h5' : 'h4'}
              component="h1"
              sx={{
                fontWeight: 600,
                lineHeight: 1.2,
                color: theme.palette.text.primary
              }}
            >
              {isMainFormRoute
                ? 'Medication Incident Report'
                : 'Medication Incident Follow-Up Form'}
            </Typography>
          </Box>

          <Typography
            variant={isMobile ? 'body2' : 'subtitle1'}
            sx={{
              color: 'text.secondary',
              maxWidth: 600,
              margin: '0 auto',
              px: isMobile ? 1 : 2,
              lineHeight: 1.4
            }}
          >
            Ultra Care Services -{' '}
            {isMainFormRoute
              ? 'For incidents involving medication'
              : 'For follow-up actions on medication incidents'}
          </Typography>
        </Box>

        {/* Success/Error Messages */}
        {message && (
          <Alert
            severity="success"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearMedicationIncidentState())}
          >
            {message}
          </Alert>
        )}
        {error && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearMedicationIncidentState())}
          >
            {error}
          </Alert>
        )}
        {clientsError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setClientsError(null)}>
            {clientsError}
          </Alert>
        )}
        {staffError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setStaffError(null)}>
            {staffError}
          </Alert>
        )}
        {(mainForm.formState.errors.root || followUpForm.formState.errors.root) && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {mainForm.formState.errors.root?.message ||
              followUpForm.formState.errors.root?.message ||
              'Please check all fields and try again.'}
          </Alert>
        )}
        {isFollowUpRoute && alreadyFilled && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            This follow-up form has already been filled.
          </Alert>
        )}

        {isMainFormRoute && (
          <form onSubmit={mainForm.handleSubmit(onSubmitMain)}>
            {/* General Information */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUser
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  General Information
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="date"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date of Incident"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.date}
                        helperText={mainForm.formState.errors.date?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="time"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Time of Incident"
                        type="time"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaClock size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.time}
                        helperText={mainForm.formState.errors.time?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="location"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Location"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaMapMarkerAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.location}
                        helperText={mainForm.formState.errors.location?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="client_name"
                    control={mainForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          {...field}
                          options={clientsList}
                          getOptionLabel={(option) => option.label || ''}
                          value={clientsList.find((client) => client.label === field.value) || null}
                          onChange={(_, newValue) => {
                            field.onChange(newValue ? newValue.label : '');
                          }}
                          loading={isClientsLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label="Client's Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <>
                                    {isClientsLoading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                )
                              }}
                              error={!!mainForm.formState.errors.client_name}
                              helperText={mainForm.formState.errors.client_name?.message}
                            />
                          )}
                          noOptionsText="No clients found"
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="support_worker_name"
                    control={mainForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          {...field}
                          options={supportWorkers}
                          getOptionLabel={(option) => option.name || ''}
                          value={
                            supportWorkers.find((worker) => worker.name === field.value) || null
                          }
                          onChange={(_, newValue) => {
                            field.onChange(newValue ? newValue.name : '');
                          }}
                          loading={staffLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label="Support Worker's Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <>
                                    {staffLoading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                )
                              }}
                              error={!!mainForm.formState.errors.support_worker_name}
                              helperText={mainForm.formState.errors.support_worker_name?.message}
                            />
                          )}
                          noOptionsText="No support workers found"
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Medication Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaPills
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.error.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Medication Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <Controller
                    name="medication_details"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Medication Involved (e.g., morning/dinner meds)"
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.medication_details}
                        helperText={mainForm.formState.errors.medication_details?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Nature of Incident
                    </Typography>
                    <Controller
                      name="nature_of_incident"
                      control={mainForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2,
                            flexWrap: 'wrap'
                          }}
                        >
                          <FormControlLabel
                            value="Damaged"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Damaged
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Missed"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Missed</Typography>
                            }
                          />
                          <FormControlLabel
                            value="Wrong dose"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Wrong dose
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Wrong person"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Wrong person
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Wrong time"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Wrong time
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Procedure error"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Procedure error
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Refused"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Refused
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Other"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Other</Typography>
                            }
                          />
                          <FormControlLabel
                            value="Medication missing"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Medication missing
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Medication vomited"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Medication vomited
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {mainForm.formState.errors.nature_of_incident && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {mainForm.formState.errors.nature_of_incident.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {nature_of_incident === 'Other' && (
                  <Grid item xs={12}>
                    <Controller
                      name="other_incident_details"
                      control={mainForm.control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          label="Please Specify Other Incident Details"
                          fullWidth
                          margin="normal"
                          {...field}
                          error={!!mainForm.formState.errors.other_incident_details}
                          helperText={mainForm.formState.errors.other_incident_details?.message}
                        />
                      )}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Controller
                    name="description"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Detailed Description"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.description}
                        helperText={mainForm.formState.errors.description?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="immediate_actions"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Immediate Actions Taken"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.immediate_actions}
                        helperText={mainForm.formState.errors.immediate_actions?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Was the Incident Reported to a Healthcare Professional?
                    </Typography>
                    <Controller
                      name="reported_to_healthcare"
                      control={mainForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {mainForm.formState.errors.reported_to_healthcare && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {mainForm.formState.errors.reported_to_healthcare.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {reported_to_healthcare === 'Yes' && (
                  <Grid item xs={12}>
                    <Controller
                      name="healthcare_contact"
                      control={mainForm.control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          label="Name and Contact Information"
                          fullWidth
                          margin="normal"
                          {...field}
                          error={!!mainForm.formState.errors.healthcare_contact}
                          helperText={mainForm.formState.errors.healthcare_contact?.message}
                        />
                      )}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Controller
                    name="recommendations"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Recommendations to Prevent Future Incidents"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.recommendations}
                        helperText={mainForm.formState.errors.recommendations?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="photo"
                    control={mainForm.control}
                    render={({ field: { onChange, onBlur, ...field } }) => (
                      <Box>
                        <TextField
                          size="small"
                          label="Upload Photo"
                          type="file"
                          fullWidth
                          margin="normal"
                          inputRef={fileInputRef}
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FaCamera size={16} />
                              </InputAdornment>
                            ),
                            inputProps: {
                              accept: 'image/*'
                            }
                          }}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handleImageChange(e, onChange)
                          }
                          onBlur={onBlur}
                          error={!!mainForm.formState.errors.photo}
                          helperText={mainForm.formState.errors.photo?.message}
                        />
                        {previewImage && isLargeScreen && (
                          <Box sx={{ mt: 1, textAlign: 'left' }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                              Photo Preview
                            </Typography>
                            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                              <Avatar
                                src={previewImage}
                                variant="rounded"
                                sx={{
                                  width: isMobile ? '100%' : 150,
                                  height: 150,
                                  objectFit: 'contain'
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={handleRemoveImage}
                                sx={{
                                  position: 'absolute',
                                  top: -10,
                                  right: -10,
                                  bgcolor: theme.palette.error.main,
                                  color: theme.palette.common.white,
                                  '&:hover': {
                                    bgcolor: theme.palette.error.dark
                                  }
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    )}
                  />
                </Grid>
                {previewImage && !isLargeScreen && (
                  <Grid item xs={12}>
                    <Box
                      sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
                    >
                      <Box sx={{ position: 'relative' }}>
                        <Avatar
                          src={previewImage}
                          variant="rounded"
                          sx={{
                            width: isMobile ? '100%' : 150,
                            height: isMobile ? 150 : 150,
                            mt: isMobile ? 1 : 0,
                            objectFit: 'contain'
                          }}
                        />
                        <IconButton
                          size="small"
                          onClick={handleRemoveImage}
                          sx={{
                            position: 'absolute',
                            top: -10,
                            right: -10,
                            bgcolor: theme.palette.error.main,
                            color: theme.palette.common.white,
                            '&:hover': {
                              bgcolor: theme.palette.error.dark
                            }
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>

            {/* Support Worker Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUser
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Support Worker Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="support_worker_name"
                    control={mainForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          {...field}
                          options={supportWorkers}
                          getOptionLabel={(option) => option.name || ''}
                          value={
                            supportWorkers.find((worker) => worker.name === field.value) || null
                          }
                          onChange={(_, newValue) => {
                            field.onChange(newValue ? newValue.name : '');
                          }}
                          loading={staffLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label="Support Worker's Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <>
                                    {staffLoading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                )
                              }}
                              error={!!mainForm.formState.errors.support_worker_name}
                              helperText={mainForm.formState.errors.support_worker_name?.message}
                            />
                          )}
                          noOptionsText="No support workers found"
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="support_worker_signature"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Signature"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaSignature size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.support_worker_signature}
                        helperText={mainForm.formState.errors.support_worker_signature?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="date_completed"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date Completed"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.date_completed}
                        helperText={mainForm.formState.errors.date_completed?.message}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons for Main Form */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetMain}
                disabled={!mainForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Report'}
              </Button>
            </Box>
          </form>
        )}

        {isFollowUpRoute && (
          <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
            {/* General Information for Follow-Up */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUser
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  General Information
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="client_name"
                    control={followUpForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          {...field}
                          options={clientsList}
                          getOptionLabel={(option) => option.label || ''}
                          value={clientsList.find((client) => client.label === field.value) || null}
                          onChange={(_, newValue) => {
                            field.onChange(newValue ? newValue.label : '');
                          }}
                          loading={isClientsLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label="Client's Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <>
                                    {isClientsLoading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                )
                              }}
                              error={!!followUpForm.formState.errors.client_name}
                              helperText={followUpForm.formState.errors.client_name?.message}
                            />
                          )}
                          noOptionsText="No clients found"
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="support_worker_name"
                    control={followUpForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          {...field}
                          options={supportWorkers}
                          getOptionLabel={(option) => option.name || ''}
                          value={
                            supportWorkers.find((worker) => worker.name === field.value) || null
                          }
                          onChange={(_, newValue) => {
                            field.onChange(newValue ? newValue.name : '');
                          }}
                          loading={staffLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label="Support Worker's Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <>
                                    {staffLoading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                )
                              }}
                              error={!!followUpForm.formState.errors.support_worker_name}
                              helperText={
                                followUpForm.formState.errors.support_worker_name?.message
                              }
                            />
                          )}
                          noOptionsText="No support workers found"
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Follow-Up Actions */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaCheckCircle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.success.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Follow-Up Actions
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Was the Incident Reported to a Healthcare Professional?
                    </Typography>
                    <Controller
                      name="reported_to_healthcare"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.reported_to_healthcare && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.reported_to_healthcare.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {reported_to_healthcare === 'Yes' && (
                  <Grid item xs={12}>
                    <Controller
                      name="healthcare_contact"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          label="Name and Contact Information"
                          fullWidth
                          margin="normal"
                          {...field}
                          error={!!followUpForm.formState.errors.healthcare_contact}
                          helperText={followUpForm.formState.errors.healthcare_contact?.message}
                        />
                      )}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Is the Incident Resolved?
                    </Typography>
                    <Controller
                      name="resolved"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.resolved && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.resolved.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="recommendations"
                    control={followUpForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Recommendations to Prevent Future Incidents"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!followUpForm.formState.errors.recommendations}
                        helperText={followUpForm.formState.errors.recommendations?.message}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons for Follow-Up Form */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetFollowUp}
                disabled={!followUpForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading || !incidentId || alreadyFilled}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Follow-Up'}
              </Button>
            </Box>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default MedicationIncidentReportForm;
